// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fullscreen"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.34315 17.6569L17.6569 6.34314M18.5 11V5.5H13M5.5 13V18.5H11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FullscreenIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fullscreen',
    ref,
    icon: element,
  },
));

FullscreenIcon.displayName = 'FullscreenIcon';

export default FullscreenIcon;
